import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fffb780"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-item border border-solid rounded border-gray-100 shadow-md px-2 py-2 bg-white" }
const _hoisted_2 = { class: "text-2xl text-black font-bold" }
const _hoisted_3 = { class: "text-sm text-gray-500" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-4" }, null, -1))
const _hoisted_5 = { class: "product-add-to-cart flex flex-row my-3" }
const _hoisted_6 = { class: "flex-1 flex flex-col" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "first-name",
  class: "block text-xs font-medium text-gray-700 uppercase mb-1"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "Prezzo")
], -1))
const _hoisted_8 = { class: "text-2xl font-bold" }
const _hoisted_9 = { class: "prezzo" }
const _hoisted_10 = { class: "flex-1 flex flex-col" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "first-name",
  class: "block text-xs font-medium text-gray-700 uppercase mb-1"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "Formato")
], -1))
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "formato" }
const _hoisted_14 = { class: "flex-1 flex flex-col" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "first-name",
  class: "block text-xs font-medium text-gray-700 uppercase mb-1"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "Quantità")
], -1))
const _hoisted_16 = { class: "justify-center" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 2,
  class: "-ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M438.6 105.4c12.5 12.5 12.5 32.7 0 45.2l-256 256c-12.5 12.5-32.7 12.5-45.2 0L9.372 278.6c-12.496-12.5-12.496-32.7 0-45.2 12.498-12.5 32.758-12.5 45.258 0L159.1 338.7l234.3-233.3c12.5-12.52 32.7-12.52 45.2 0z"
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Stepper = _resolveComponent("Stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.prodotto.nome), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.prodotto.descr), 1),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("p", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, "€ " + _toDisplayString(_ctx.prezzo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.prodotto.formato), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Stepper, {
            modelValue: _ctx.qta,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.qta) = $event)),
            integer: "",
            min: "1",
            "input-width": "calc(100% - 70px)",
            "button-size": "32px"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.add2cart && _ctx.add2cart(...args))),
      class: _normalizeClass(["inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 w-full", {stato_btn: 'opacity-80 cursor-not-allowed'}])
    }, [
      (!_ctx.stato_btn)
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Aggiungi"))
        : _createCommentVNode("", true),
      (_ctx.stato_btn == 'loading')
        ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _hoisted_21))
        : _createCommentVNode("", true),
      (_ctx.stato_btn == 'done')
        ? (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_24))
        : _createCommentVNode("", true)
    ])
  ]))
}